import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { KmInstructionsCommand } from '@app/models/production/km-instructions';

@Injectable({ providedIn: 'root' })
export class KmInstructionsProxyService {
  private readonly httpClient = inject(HttpClient);
  private readonly baseUrl = environment.proxyUrls.productionApi + '/api/v1/km-instructions';

  public generateBatch(command: KmInstructionsCommand): Observable<Blob> {
    return this.httpClient.post(`${this.baseUrl}/batch`, command, { responseType: 'blob' });
  }
}
